module.exports = __webpack_public_path__ + "static/media/sort-size-up.741c9bcd.svg";